import React  from 'react';


const UserInfo = (props) => {
    let requesterID = ''
    let employeeName = '';
    let positionName = '';
    let orgnizationUnitName = '';
    let reportingToEmployeeName = '';
    let requestNmbrHead = 'Request Number';
    let processId = props.processId;
    if(props.userObject!==null){
        requesterID = (props.userObject.loginId!==undefined) ? props.userObject.loginId : 'N/A';
        employeeName = (props.userObject.userName!==undefined) ? props.userObject.userName : 'N/A';
        positionName = (props.userObject.positionName!==undefined && props.userObject.positionName!==null) ? props.userObject.positionName : 'N/A';
        orgnizationUnitName = (props.userObject.orgnizationUnitName!==undefined && props.userObject.orgnizationUnitName!==null) ? props.userObject.orgnizationUnitName : 'N/A';
        reportingToEmployeeName = (props.userObject.reportingToEmployeeName!==undefined && props.userObject.reportingToEmployeeName!==null) ? props.userObject.reportingToEmployeeName : 'N/A';
        if(processId){
            if(processId.toLowerCase() == "236d1c03-5b22-480e-b32f-8f48b4882fa5") requestNmbrHead = "WCA Number";
        }
        
    }

    let requestNum = '';
    if(props.requestNum!==undefined && props.requestNum!==null){
        requestNum = props.requestNum;
    }


    let doj = 'N/A';
    if(props.doj!==undefined && props.doj!==null){
        doj = props.doj;
    }else{
        if(localStorage.getItem('doj')){
            doj = localStorage.getItem('doj');
        }
    }



    return(

        <div className="p-grid empDetailBg">
            {employeeName !=='' && 
            <>
            <div className="p-col-12 p-md-4 p-sm-4 p-lg-2">
                <label className="label">User ID &amp; Name</label>
                <p><b>{`${requesterID} & ${employeeName}` }</b></p>                                
            </div>
         
             <div className="p-col-12 p-md-4 p-sm-4 p-lg-2">
                <label className="label">Position &amp; Org Unit</label>
                <p><b>{`${positionName} & ${orgnizationUnitName}`}</b></p>                                
            </div>

            <div className="p-col-12 p-md-4 p-sm-4 p-lg-2">
                <label className="label">DOJ</label>
                <p><b>{doj}</b></p>                                
            </div>
     
            <div className="p-col-12 p-md-4 p-sm-4 p-lg-2">
                <label className="label">Reporting To Manager</label>
                <p><b>{reportingToEmployeeName}</b></p>                                
            </div>
            </>
            }
            {
                (requestNum !=='') &&
                <div className="p-col-12 p-md-4 p-sm-4 p-lg-2">
                    <label className="label">{requestNmbrHead}</label>
                    <p style={{color:'red'}}><b>{requestNum}</b></p>                                
                </div>
            }
            

            
        </div>

   )
}

export default UserInfo;